import {
  SIGNIN,
  SIGNIN_SUCCESS,
  SIGNIN_FAILURE,
  VERIFY_2FA,
  VERIFY_2FA_SUCCESS,
  VERIFY_2FA_FAILURE,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  USER_PROFILE,
  USER_PROFILE_SUCCESS,
  USER_PROFILE_FAILURE,
  LAST_SEEN_TOGGLE,
  LAST_SEEN_TOGGLE_SUCCESS,
  LAST_SEEN_TOGGLE_FAILURE,
  CREATE_CONTACT,
  CREATE_CONTACT_SUCCESS,
  CREATE_CONTACT_FAILURE,
  DELETE_CONTACT,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_FAILURE,
  UPDATE_CONTACT,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_FAILURE,
  LIST_CONTACTS,
  LIST_CONTACTS_SUCCESS,
  LIST_CONTACTS_FAILURE,
  PASSCODE_TOGGLE,
  PASSCODE_TOGGLE_SUCCESS,
  PASSCODE_TOGGLE_FAILURE,
  VERIFY_PASSCODE,
  VERIFY_PASSCODE_SUCCESS,
  VERIFY_PASSCODE_FAILURE,
  UPDATE_PASSCODE,
  UPDATE_PASSCODE_SUCCESS,
  UPDATE_PASSCODE_FAILURE,
  APP_LOCK_TRIGGER,
  APP_UNLOCK,
  APP_LOCK_TIMER_START,
  APP_LOCK_TIMER_STOP,
  CONTACT_SUPPORT,
  CONTACT_SUPPORT_SUCCESS,
  CONTACT_SUPPORT_FAILURE,
} from '../constants';

export default class AppAction {
  static SignIn(payload, cb) {
    return {
      type: SIGNIN,
      payload,
      cb,
    };
  }
  static SignInSuccess(payload) {
    return {
      type: SIGNIN_SUCCESS,
      payload,
    };
  }
  static SignInFailure() {
    return {
      type: SIGNIN_FAILURE,
    };
  }

  // 2FA login challenge: exchange the mfa_token + code for a real session.
  static Verify2fa(payload, cb) {
    return {
      type: VERIFY_2FA,
      payload,
      cb,
    };
  }
  static Verify2faSuccess(payload) {
    return {
      type: VERIFY_2FA_SUCCESS,
      payload,
    };
  }
  static Verify2faFailure() {
    return {
      type: VERIFY_2FA_FAILURE,
    };
  }

  static UserProfile(payload, cb) {
    return {
      type: USER_PROFILE,
      payload,
      cb,
    };
  }
  static UserProfileSuccess(payload) {
    return {
      type: USER_PROFILE_SUCCESS,
      payload,
    };
  }
  static UserProfileFailure() {
    return {
      type: USER_PROFILE_FAILURE,
    };
  }

  static ChangePassword(payload, cb) {
    return {
      type: CHANGE_PASSWORD,
      payload,
      cb,
    };
  }
  static ChangePasswordSuccess(payload) {
    return {
      type: CHANGE_PASSWORD_SUCCESS,
      payload,
    };
  }
  static ChangePasswordFailure() {
    return {
      type: CHANGE_PASSWORD_FAILURE,
    };
  }

  static Logout(cb) {
    return {
      type: LOGOUT,
      cb,
    };
  }
  static LogoutSuccess() {
    return {
      type: LOGOUT_SUCCESS,
    };
  }
  static LogoutFailure() {
    return {
      type: LOGOUT_FAILURE,
    };
  }
  static LastSeenToggle(payload, cb) {
    return {
      type: LAST_SEEN_TOGGLE,
      payload,
      cb,
    };
  }

  static LastSeenToggleSuccess(data) {
    return {
      type: LAST_SEEN_TOGGLE_SUCCESS,
      data,
    };
  }

  static LastSeenToggleFailure() {
    return {
      type: LAST_SEEN_TOGGLE_FAILURE,
    };
  }

  // static AddPost(payload) {
  //     return {
  //         type: ADD_POST,
  //         payload
  //     }
  // }
  // static AddPostSuccess(payload) {
  //     return {
  //         type: ADD_POST_SUCCESS,
  //         payload
  //     }
  // }
  // static AddPostFailure() {
  //     return {
  //         type: ADD_POST_FAILURE
  //     }
  // }

  // static GetPosts() {
  //     return {
  //         type: GET_POSTS
  //     }
  // }
  // static GetPostsSuccess(payload) {
  //     return {
  //         type: GET_POSTS_SUCCESS,
  //         payload
  //     }
  // }
  // static GetPostsFailure() {
  //     return {
  //         type: GET_POSTS_FAILURE
  //     }
  // }

  // static LoaderTrue() {
  //     return {
  //         type: LOADER_TRUE
  //     }
  // }
  // static LoaderFalse() {
  //     return {
  //         type: LOADER_FALSE
  //     }
  // }

  //CONTACT_ACTIONS

  //create
  static CreateContact(payload, cb) {
    return { type: CREATE_CONTACT, payload, cb };
  }
  static CreateContactSuccess(payload) {
    return { type: CREATE_CONTACT_SUCCESS, payload };
  }
  static CreateContactFailure() {
    return { type: CREATE_CONTACT_FAILURE };
  }

  //delete
  static DeleteContact(id, cb) {
    return { type: DELETE_CONTACT, payload: id, cb };
  }
  static DeleteContactSuccess(payload) {
    return { type: DELETE_CONTACT_SUCCESS, payload };
  }
  static DeleteContactFailure() {
    return { type: DELETE_CONTACT_FAILURE };
  }

  //update
  static UpdateContact(payload, cb) {
    return { type: UPDATE_CONTACT, payload, cb };
  }
  static UpdateContactSuccess(payload) {
    return { type: UPDATE_CONTACT_SUCCESS, payload };
  }
  static UpdateContactFailure() {
    return { type: UPDATE_CONTACT_FAILURE };
  }

  //list
  static ListContacts(params, cb) {
    return { type: LIST_CONTACTS, payload: params, cb };
  }
  static ListContactsSuccess(payload) {
    return { type: LIST_CONTACTS_SUCCESS, payload };
  }
  static ListContactsFailure() {
    return { type: LIST_CONTACTS_FAILURE };
  }

  // Passcode actions
  static PasscodeToggle(payload, cb) {
    return { type: PASSCODE_TOGGLE, payload, cb };
  }
  static PasscodeToggleSuccess(payload) {
    return { type: PASSCODE_TOGGLE_SUCCESS, payload };
  }
  static PasscodeToggleFailure() {
    return { type: PASSCODE_TOGGLE_FAILURE };
  }

  static VerifyPasscode(payload, cb) {
    return { type: VERIFY_PASSCODE, payload, cb };
  }
  static VerifyPasscodeSuccess() {
    return { type: VERIFY_PASSCODE_SUCCESS };
  }
  static VerifyPasscodeFailure() {
    return { type: VERIFY_PASSCODE_FAILURE };
  }

  static UpdatePasscode(payload, cb) {
    return { type: UPDATE_PASSCODE, payload, cb };
  }
  static UpdatePasscodeSuccess(payload) {
    return { type: UPDATE_PASSCODE_SUCCESS, payload };
  }
  static UpdatePasscodeFailure() {
    return { type: UPDATE_PASSCODE_FAILURE };
  }

  // App lock/unlock state
  static AppLockTrigger() {
    return { type: APP_LOCK_TRIGGER };
  }
  static AppUnlock() {
    return { type: APP_UNLOCK };
  }

  static AppLockTimerStart(payload) {
    return { type: APP_LOCK_TIMER_START, payload };
  }
  static AppLockTimerStop() {
    return { type: APP_LOCK_TIMER_STOP };
  }

  // Contact Support
  static ContactSupport(payload, cb) {
    return { type: CONTACT_SUPPORT, payload, cb };
  }
  static ContactSupportSuccess(payload) {
    return { type: CONTACT_SUPPORT_SUCCESS, payload };
  }
  static ContactSupportFailure() {
    return { type: CONTACT_SUPPORT_FAILURE };
  }
}
